enum EIppAASAuthoritySettingsActionType {
	FetchIppAASAuthoritySettingsData = 'fetchIppAASAuthoritySettingsData',
	UpdateIppAASAuthoritySettingsData = 'updateIppAASAuthoritySettingsData',
	SaveIppAASAuthoritySettingsData = 'saveIppAASAuthoritySettingsData',
	ToggleSaveButton = 'ToggleSaveButton'
}

export default EIppAASAuthoritySettingsActionType;
